import User from './user';

const mainStore = {
  user: User,
  businesses: [],
  business: null,

  keyAdderVisible: false,
};

export default mainStore;
